export var TrackingId;
(function (TrackingId) {
    TrackingId[TrackingId["CategoryClick"] = 4] = "CategoryClick";
    TrackingId[TrackingId["AccountInteraction"] = 46] = "AccountInteraction";
    TrackingId[TrackingId["NewsletterPerk"] = 21] = "NewsletterPerk";
    TrackingId[TrackingId["PerkSearchListings"] = 26] = "PerkSearchListings";
    TrackingId[TrackingId["ReferralLinks"] = 30] = "ReferralLinks";
    TrackingId[TrackingId["SearchSubmission"] = 34] = "SearchSubmission";
    TrackingId[TrackingId["PerkInteraction"] = 45] = "PerkInteraction";
    TrackingId[TrackingId["Redemption"] = 48] = "Redemption";
    TrackingId[TrackingId["StoryClick"] = 52] = "StoryClick";
    TrackingId[TrackingId["WBEPageNotificationClick"] = 59] = "WBEPageNotificationClick";
    TrackingId[TrackingId["WBEPopupClick"] = 65] = "WBEPopupClick";
    TrackingId[TrackingId["PageView"] = 80] = "PageView";
    TrackingId[TrackingId["UserRegistrationInteraction"] = 81] = "UserRegistrationInteraction";
    TrackingId[TrackingId["Pagination"] = 82] = "Pagination";
    TrackingId[TrackingId["PromotionViewAll"] = 83] = "PromotionViewAll";
    TrackingId[TrackingId["RelatedViewAll"] = 84] = "RelatedViewAll";
    TrackingId[TrackingId["NotificationInteraction"] = 67] = "NotificationInteraction";
    TrackingId[TrackingId["PopUpInteraction"] = 68] = "PopUpInteraction";
    TrackingId[TrackingId["AlertBannerInteraction"] = 69] = "AlertBannerInteraction";
})(TrackingId || (TrackingId = {}));
export var TrackingAction;
(function (TrackingAction) {
    TrackingAction["Loaded"] = "load";
    TrackingAction["View"] = "view";
    TrackingAction["Click"] = "click";
    TrackingAction["Submit"] = "submit";
})(TrackingAction || (TrackingAction = {}));
export var SortType;
(function (SortType) {
    SortType[SortType["Distance"] = 1] = "Distance";
    SortType[SortType["Name"] = 2] = "Name";
    SortType[SortType["RecentlyUpdated"] = 3] = "RecentlyUpdated";
})(SortType || (SortType = {}));
export var PerkTrackingElement;
(function (PerkTrackingElement) {
    PerkTrackingElement["PerkCard"] = "PerkCard";
    PerkTrackingElement["Banner"] = "Banner";
    PerkTrackingElement["Story"] = "Story";
    PerkTrackingElement["Tag"] = "Tag";
    PerkTrackingElement["CategoryCard"] = "CategoryCard";
    PerkTrackingElement["AccountCard"] = "AccountCard";
    PerkTrackingElement["TopBrand"] = "TopBrand";
    PerkTrackingElement["Redemption"] = "Redemption";
    PerkTrackingElement["TemplatePerks"] = "TemplatePerks";
})(PerkTrackingElement || (PerkTrackingElement = {}));
export var TrackingElement;
(function (TrackingElement) {
    TrackingElement["UserAccountRegistration"] = "UserAccountRegistration";
    TrackingElement["Pagination"] = "Pagination";
    TrackingElement["PromotionViewAll"] = "PromotionViewAll";
    TrackingElement["RelatedViewAll"] = "RelatedViewAll";
    TrackingElement["Popup"] = "Popup";
    TrackingElement["AlertBanner"] = "AlertBanner";
    TrackingElement["AgreeAndPlayButton"] = "AgreeAndPlayButton";
    TrackingElement["PopUpSpinWheelButton"] = "PopUpSpinWheelButton";
    TrackingElement["DoNotShowButton"] = "DoNotShowButton";
    TrackingElement["PopupCTA"] = "PopupCTA";
    TrackingElement["NotificationPanel"] = "NotificationPanel";
    TrackingElement["NotificationDetail"] = "NotificationDetail";
    TrackingElement["NotificationList"] = "NotificationList";
    TrackingElement["NotificationBell"] = "NotificationBell";
})(TrackingElement || (TrackingElement = {}));
export var CategoryTrackingElement;
(function (CategoryTrackingElement) {
    CategoryTrackingElement["Menu"] = "Menu";
    CategoryTrackingElement["CategoryCard"] = "CategoryCard";
    CategoryTrackingElement["CategoryTextLink"] = "CategoryTextLink";
    CategoryTrackingElement["RelatedViewAll"] = "RelatedViewAll";
})(CategoryTrackingElement || (CategoryTrackingElement = {}));
// PAGES = ["Home Page", "Category Page", "Perk Details Page"]
// PerkTileImpressionLoaded
// PerkTileImpressionView
// HeroPerkImpressionLoaded
// HeroPerkImpressionView
export var PageName;
(function (PageName) {
    PageName[PageName["Home"] = 1] = "Home";
    PageName[PageName["CategoryHome"] = 2] = "CategoryHome";
    PageName[PageName["Perk"] = 3] = "Perk";
    PageName[PageName["Search"] = 4] = "Search";
    PageName[PageName["Settings"] = 5] = "Settings";
    PageName[PageName["AccountCreation"] = 6] = "AccountCreation";
    PageName[PageName["Favourites"] = 7] = "Favourites";
    PageName[PageName["GetActivationCode"] = 8] = "GetActivationCode";
    PageName[PageName["CheckYourEmail"] = 9] = "CheckYourEmail";
    PageName[PageName["CreateYourAccount"] = 10] = "CreateYourAccount";
    PageName[PageName["AddLocation"] = 11] = "AddLocation";
    PageName[PageName["NewsletterSubscription"] = 12] = "NewsletterSubscription";
    PageName[PageName["TermsOfUse"] = 13] = "TermsOfUse";
    PageName[PageName["MobileAppDownload"] = 14] = "MobileAppDownload";
    PageName[PageName["MobileAppDownloadSkip"] = 15] = "MobileAppDownloadSkip";
    PageName[PageName["MobileAppDownloadSend"] = 16] = "MobileAppDownloadSend";
    PageName[PageName["Congratulations"] = 17] = "Congratulations";
    PageName[PageName["TemplatePerks"] = 19] = "TemplatePerks";
    PageName[PageName["FavouriteBrand"] = 20] = "FavouriteBrand";
    PageName[PageName["RelatedPerksViewAll"] = 21] = "RelatedPerksViewAll";
    PageName[PageName["Interstitial"] = 22] = "Interstitial";
    PageName[PageName["NotificationList"] = 23] = "NotificationList";
})(PageName || (PageName = {}));
export var PerkSource;
(function (PerkSource) {
    PerkSource["VenngoCA"] = "Venngo-CA";
    PerkSource["VenngoUS"] = "Venngo-US";
    PerkSource["AccessUS"] = "Access-US";
})(PerkSource || (PerkSource = {}));
export var Country;
(function (Country) {
    Country["CA"] = "CA";
    Country["US"] = "US";
})(Country || (Country = {}));
export var Source;
(function (Source) {
    Source["Web"] = "web";
    Source["Mobile"] = "mobile";
    Source["MobileWeb"] = "mobile-web";
    Source["WebBrowserExtension"] = "web-extension";
    Source["Newsletter"] = "newsletter";
})(Source || (Source = {}));
export var WebExtensionElement;
(function (WebExtensionElement) {
    WebExtensionElement["WBEPopupClick"] = "PopupClick";
    WebExtensionElement["WBEPageNotificationClick"] = "PageNotificationClick";
})(WebExtensionElement || (WebExtensionElement = {}));
export const PERK_ROUTE_TRACKING_ID_MAP = {
// FIXME: Should have its own TrackingId.
// BrowsePerks: TrackingId.PerkSearchListingsClick,
// CategoryHome: TrackingId.PerkCategoryListingsViewButton,
// Search: TrackingId.PerkSearchListingsClick,
// Favourites: TrackingId.UserFavouritesListings,
// HomeView: TrackingId.WelcomeHomeScrollPod,
};
export function isPerkClickHit(trackingHit) {
    return trackingHit.perk_id !== undefined;
}
